import round from "../number/round";

// converts from mmol/L to mg/dL
export default function mmolToMg(value, precision = 1) {
  if (value === undefined) {
    return undefined;
  }
  return round(value * 18, precision);
}
